<template>
  <div class="app-main-content report-setting">
    <div class="tabs-container">
      <el-tabs v-model="activeTabName" :lazy="true" type="card" style="width:100%;">
        <el-tab-pane v-if="tabCopyMonthSettingIsShowed" :label="$t('PillReport.CopyMonthSetting')" name="copyMonthSetting">
          <tab-copy-month-setting :is-show="copyMonthSettingIsShow" />
        </el-tab-pane>
        <el-tab-pane v-if="tabFinanceSettingIsShowed" :label="$t('PillReport.FinanceSetting')" name="financeSetting">
          <tab-finance-setting :is-show="financeSettingIsShow" />
        </el-tab-pane>
        <el-tab-pane v-if="tabHrSettingIsShowed" :label="$t('PillReport.HrSetting')" name="hrSetting">
          <tab-hr-setting :is-show="hrSettingIsShow" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import tabCopyMonthSetting from './tabCopyMonthSetting'
import tabFinanceSetting from './tabFinanceSetting'
import tabHrSetting from './tabHrSetting'

export default {
  name: 'ReportSetting',
  components: { tabCopyMonthSetting, tabFinanceSetting, tabHrSetting },
  props: { },
  data() {
    return {
      loading: false,
      activeTabName: 'copyMonthSetting',
      tabCopyMonthSettingIsShowed: this.$checkPermission(['tab_ReportSetting_copyMonthSetting']),
      tabFinanceSettingIsShowed: this.$checkPermission(['tab_ReportSetting_financeSetting']),
      tabHrSettingIsShowed: this.$checkPermission(['tab_ReportSetting_hrSetting']),
      copyMonthSettingIsShowed: false,
      financeSettingIsShowed: false,
      hrSettingIsShowed: false
    }
  },
  computed: {
    copyMonthSettingIsShow() {
      if (this.activeTabName === 'copyMonthSetting' && !this.copyMonthSettingIsShowed) {
        this.copyMonthSettingIsShowed = true
      }
      return this.copyMonthSettingIsShowed
    },
    financeSettingIsShow() {
      if (this.activeTabName === 'financeSetting' && !this.financeSettingIsShowed) {
        this.financeSettingIsShowed = true
      }
      return this.financeSettingIsShowed
    },
    hrSettingIsShow() {
      if (this.activeTabName === 'hrSetting' && !this.hrSettingIsShowed) {
        this.hrSettingIsShowed = true
      }
      return this.hrSettingIsShowed
    }
  },
  created() {
    this.defaultActiveTabName()
  },
  methods: {
    defaultActiveTabName() {
      if (this.tabCopyMonthSettingIsShowed) {
        this.activeTabName = 'copyMonthSetting'
      } else if (this.tabFinanceSettingIsShowed) {
        this.activeTabName = 'financeSetting'
      } else if (this.tabHrSettingIsShowed) {
        this.activeTabName = 'hrSetting'
      }
    }
  }
}
</script>

<style lang="scss">

</style>
